import { render, staticRenderFns } from "./StarorderProgress.vue?vue&type=template&id=460dd704&scoped=true&"
import script from "./StarorderProgress.vue?vue&type=script&lang=js&"
export * from "./StarorderProgress.vue?vue&type=script&lang=js&"
import style0 from "./StarorderProgress.vue?vue&type=style&index=0&id=460dd704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460dd704",
  null
  
)

component.options.__file = "StarorderProgress.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBadge,
  VFlex,
  VIcon,
  VLayout,
})
